import { useInstance } from '@meraki-internal/react-dependency-injection';
import { Card } from '../components/Card';
import { Text } from '../components/Text';
import { IonButton } from '@ionic/react';
import { CareMapState } from '../caremap/CareMapState';
import { useSubscription } from '@meraki-internal/state';
import { NewCareMapWizard } from '../wizard/mini-wizard/wizards/NewCareMapWizard';
import { InnerhiveSVGIcon } from '../theme/Icons';

export const NewCaremapCTACard: React.FC = () => {
    const caremapState = useInstance(CareMapState);
    const newCareMapMiniWizard = useInstance(NewCareMapWizard);

    useSubscription(() => caremapState);

    if (caremapState.hasCareMaps()){
        return null;
    }

    const startAddingPatient = async () => {
        newCareMapMiniWizard.start();
    };

    return (
        <Card data-type="new-caremap-cta" padded onClick={startAddingPatient}>
            <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center'}}>
                <Text><b style={{textAlign: 'center'}}>Welcome to Innerhive!</b></Text>
                <div style={{marginTop: 5, marginBottom: 5, textAlign: 'center'}}>
                    <Text type="detail">
                        This is the place to organize care responsibilities, build your support community, keep others in the loop, and get guided support.<br /><br /><br /> Add a Care Recipient below to get started!
                    </Text>
                </div>
                <IonButton
                    fill="clear"
                    color="primary"
                    data-id="add-patient-button"
                    onClick={startAddingPatient}
                >
                    {InnerhiveSVGIcon}&nbsp;Add Care Recipient
                </IonButton>
            </div>
        </Card>
    );
};
